import { QuickBetModalsTypes } from 'og-web-core/providers/bet/types'

export const modalsTitles: Record<QuickBetModalsTypes, string> = {
  [QuickBetModalsTypes.coefficientChanged]: 'coefficient changed',
  [QuickBetModalsTypes.confirmQuickBet]: 'one click bet',
  [QuickBetModalsTypes.lowerBalance]: 'low balance',
  [QuickBetModalsTypes.quickBetSettings]: 'one click bet'
}
